import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Link } from '@mui/material';

export const FileStorefrontLink = ({ advisorLogin }) => {
  if (!advisorLogin) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 24,
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        padding: '12px 24px',
        borderRadius: '8px',
        pointerEvents: 'auto',
        zIndex: 9999,
      }}
    >
      <Typography
        variant="h6"
        color="white"
        sx={{ fontSize: '1.25rem' }}
      >
        <Link
          href={`/${advisorLogin}`}
          color="inherit"
          underline="hover"
          sx={{ fontWeight: 600 }}
        >
          {`${advisorLogin}'s Storefront`}
        </Link>
      </Typography>
    </Box>
  );
};

FileStorefrontLink.propTypes = {
  advisorLogin: PropTypes.string.isRequired,
};
